// extracted by mini-css-extract-plugin
export default {"base":"vp_dBNHm"};